import React from 'react'
import './index.css'
import EditRatingBottomSheet from 'containers/QuickShopProductSidebar/components/EditRatingBottomSheet'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import updateVariantRatingStatusAction from 'modules/product/redux/actions/update-variant-rating-status'
import updateProductRatingStatusAction from 'modules/product/redux/actions/update-product-rating-status'
import useDispatch from 'hooks/use-dispatch'
import updateCurrentToastAction from 'modules/toast/redux/actions/update-current'
import wasDislikedSampleSelector from 'modules/variant/redux/selectors/was-disliked-sample'
import useSelector from 'hooks/use-selector'
import ReactModal from 'react-modal'
import useIsSmallScreen from 'hooks/use-is-small-screen'

const RATING_EDITED = 'Rating edited'

const ANALYTICS_EVENT = {
  SHOW_EDIT_RATING_MODAL: 'SHOW_EDIT_RATING_MODAL',
  QUICK_SHOP_PRODUCT_SIDEBAR_EDIT_RATING_CLICK_LIKE_BUTTON: 'QUICK_SHOP_PRODUCT_SIDEBAR_EDIT_RATING_CLICK_LIKE_BUTTON',
  QUICK_SHOP_PRODUCT_SIDEBAR_EDIT_RATING_CLICK_DISLIKE_BUTTON: 'QUICK_SHOP_PRODUCT_SIDEBAR_EDIT_RATING_CLICK_DISLIKE_BUTTON'
}

const EDIT_RATING_LABEL = 'Edit rating'

const QuickShopProductSidebarEditRating = ({
  variantId,
  productId,
  isFromProductPage = false
}) => {
  const [isBottomSheetOpen, setIsBottomSheetOpen] = React.useState(false)
  const isSmallScreen = useIsSmallScreen()

  const dispatch = useDispatch()

  const wasDislikedSample = useSelector(wasDislikedSampleSelector(variantId))

  const handleCloseBottomSheet = () => {
    setIsBottomSheetOpen(false)
  }

  const handleOpenBottomSheet = () => {
    setIsBottomSheetOpen(true)
    logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_EDIT_RATING_MODAL)
  }

  const showToast = () => {
    dispatch(updateCurrentToastAction(RATING_EDITED))
  }

  const handleClickLike = async (e) => {
    e.stopPropagation()
    handleCloseBottomSheet()
    showToast()
    logEventAnalyticsUtil(ANALYTICS_EVENT.QUICK_SHOP_PRODUCT_SIDEBAR_EDIT_RATING_CLICK_LIKE_BUTTON)
    await dispatch(updateVariantRatingStatusAction({
      variantId,
      rating: 'like'
    }))
    await dispatch(updateProductRatingStatusAction({
      productId,
      rating: 'like'
    }))
  }

  const handleClickDislike = async (e) => {
    e.stopPropagation()
    handleCloseBottomSheet()
    showToast()
    logEventAnalyticsUtil(ANALYTICS_EVENT.QUICK_SHOP_PRODUCT_SIDEBAR_EDIT_RATING_CLICK_DISLIKE_BUTTON)

    await dispatch(
      updateVariantRatingStatusAction({
        variantId,
        rating: 'not_like'
      })
    )

    await dispatch(
      updateProductRatingStatusAction({
        productId,
        rating: 'not_like'
      })
    )
  }

  const RenderEditRating = () => {
    if (!isFromProductPage || isSmallScreen) {
      return (
        <EditRatingBottomSheet
          onLike={handleClickLike}
          onDislike={handleClickDislike}
          onClose={handleCloseBottomSheet}
        />
      )
    }

    return (
      <ReactModal
        isOpen
        onRequestClose={handleCloseBottomSheet}
        style={{
          overlay: {
            opacity: 1
          }
        }}
      >
        <div
          className='edit-rating-modal-container'
          onClick={handleCloseBottomSheet}
        >
          <EditRatingBottomSheet
            onLike={handleClickLike}
            onDislike={handleClickDislike}
            onClose={handleCloseBottomSheet}
          />
        </div>
      </ReactModal>
    )
  }

  return (
    <div>

      <div className='product-card-edit-wrapper'>
        {wasDislikedSample && <div className='product-card-edit-rating-disliked'>Disliked</div>}
        <div onClick={handleOpenBottomSheet}>
          <h1 className='product-card-edit-rating-label'>{EDIT_RATING_LABEL}</h1>
        </div>
      </div>

      {isBottomSheetOpen && (
        <RenderEditRating />
      )}

    </div>
  )
}

export default QuickShopProductSidebarEditRating
